import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Link } from 'react-router-dom';


// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import { Modal } from 'react-bootstrap';

import TrainingStaffDate from './TrainingStaffDate';
import TrainingStaffObservations from './TrainingStaffObservations';
import getLocale from '../../../i18n/getLocale';

class TrainingStaffsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      training_id: this.props.training_id,
      updated: this.props.updated,
      staff_available_list: [],
      training_certification_staffs: [],
      modal: false,
      modal_tcs_id: [],
      modal_staff_name: null,
      modal_certification_name: null,
      modal_comment: null,
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteAll = this.deleteAll.bind(this);
    this.export = this.export.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_id !== 'undefined' && Array.isArray(newProps.staff_available_list) && newProps.training_certification_staffs !== null) || (this.state.loaded === 1 && newProps.updated === 1)){
      this.setState({
        training_id: newProps.training_id,
        staff_available_list: newProps.staff_available_list,
        training_certification_staffs: newProps.training_certification_staffs,
        loaded: 1,
      });
    }
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      training_id: this.state.training_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificados/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var training_certification_staff_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabAlunos.deletarAlunoDessaAula);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aula/remover/tripulante/' + training_certification_staff_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deleteAll (event) {
    var staff_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabAlunos.deletarAlunoDesseTreinamento);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/remover/aluno/' + self.state.training_id + '/' + staff_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  export(event) {
    var self = this;
    var staff_certification_id = event.currentTarget.value;
    var url = '/exportar/certificado/funcionario/';
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + staff_certification_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  {(self.props.status === 1 || self.props.status === 3) ? 
    <div>
      <h3 className="page-title">{this.locale.Treinamentos.EditarTreinamento.tabAlunos.tituloAdicionarAluno}</h3>
      <hr/>
      <form onSubmit={this.add}> 
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label>{this.locale.Treinamentos.EditarTreinamento.tabAlunos.formularioAdicionarAluno.Tripulante}:</label>
              <Select
                className="form-field-name"
                name="staff_id"
                value={this.state.staff_id}
                searchable={true}
                required
                placeholder={this.locale.Treinamentos.EditarTreinamento.tabAlunos.formularioAdicionarAluno.placeholder.SelecionarTripulante}
                onChange={this.handleSelectChange.bind(this, 'staff_id')}
                options={this.state.staff_available_list}
              />
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-plus"></i> {this.locale.Treinamentos.EditarTreinamento.tabAlunos.formularioAdicionarAluno.botaoAdicionarTripulante}</button>
      </form>
      <hr/>
    </div>
  :
    ''
  }
  <h3 className="page-title">{this.locale.Treinamentos.EditarTreinamento.tabAlunos.tituloListaDeAlunos}</h3>
  <hr/>
  {(this.state.training_certification_staffs === null || typeof this.state.training_certification_staffs === 'undefined') ?  <div><small><em>{this.locale.Treinamentos.EditarTreinamento.tabAlunos.nenhumAlunoCadastrado}</em></small><hr/></div> 
  : 
  <div>
    {Object.keys(self.state.training_certification_staffs).map(function(staff) {
      return(
        <div>
          <div className="title-staff-trainings">
            <h5 className="page-title pull-left">{staff}</h5>
            {(self.props.status === 1 || self.props.status === 3) ? 
              <button className="btn btn-danger pull-right" value={self.state.training_certification_staffs[staff][0].staff_id} onClick={self.deleteAll}><i className="fa fa-fw fa-trash"></i> {self.locale.Treinamentos.EditarTreinamento.tabAlunos.botaoRemoverTodasAsAulas}</button>
            :
              ''
            }
            
            <div className="clearfix"></div>
          </div>
          <table className="table table-staff-trainings">
            <tbody id="training-certification-staffs">
              {Object.keys(self.state.training_certification_staffs[staff]).map(function(k) {
                return (
                  <tr>
                    <td className="col-md-2">
                      <h5><span className="label label-default">{self.state.training_certification_staffs[staff][k].certification_name}</span></h5>
                      <h5><span className="label label-default">{self.locale.Treinamentos.EditarTreinamento.tabAlunos.tituloCertificadoDeTreinamentoDe(self.state.training_certification_staffs[staff][k].date_start_str, self.state.training_certification_staffs[staff][k].date_finish_str)}</span></h5>
                    </td>
                    <td className="col-md-4 text-center">
                      <TrainingStaffDate training_certification_staff_id={self.state.training_certification_staffs[staff][k].id} status={self.props.status} updated={self.updated} date_start={self.state.training_certification_staffs[staff][k].date_start_str} date_finish={self.state.training_certification_staffs[staff][k].date_finish_str} updateData={self.props.updateData} handleAlert={self.props.handleAlert} />
                    </td>
                    <td className="col-md-3 text-center">
                      <TrainingStaffObservations training_certification_staff_id={self.state.training_certification_staffs[staff][k].id} status={self.props.status} observations={self.state.training_certification_staffs[staff][k].observations} updateData={self.props.updateData} handleAlert={self.props.handleAlert} />
                    </td>
                    <td className="text-right col-md-2">
                      {(self.props.status === 1 || self.props.status === 3) ? 
                        <button className="btn btn-danger" value={self.state.training_certification_staffs[staff][k].id} onClick={self.delete}><i className="fa fa-fw fa-trash"></i></button>
                      :
                        ''
                      }
                    </td>
                    <td className="text-right col-md-2">
                      {(self.state.training_certification_staffs[staff][k].finalized === 1) ? 
                        <button type="button" className={"btn btn-sm btn-success"} onClick={self.export} value={self.state.training_certification_staffs[staff][k].staff_certification_id}><i className="fa fa-fw fa-file-o"></i></button>
                      :
                        ''
                      }
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    })}
    <hr/>
  </div>
  }
</div>
    );
  }
}

export default TrainingStaffsTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingStaffsTab.js